import {
  FILL_LIST,
  FILL_DETAILS,
  CHANGE_RECORD_STATUS,
} from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
  [FILL_DETAILS](state, payload) {
    const _state = state;
    _state.details.record = payload.record;
    _state.details.total = payload.total;
  },
  [CHANGE_RECORD_STATUS](state, payload) {
    // eslint-disable-next-line no-param-reassign
    payload.is_logged = !payload.is_logged;
  },
};
